import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const RegisterProviderPage = lazy(() => import('../pages/register-provider/page'));
const RegisterUserPage = lazy(() => import('../pages/register-user/page'));
const CategoriesPage = lazy(() => import('../pages/categories/page'));
const ProviderProfilePage = lazy(() => import('../pages/provider-profile/page'));
const ServiceRequestPage = lazy(() => import('../pages/service-request/page'));
const ProviderDashboardPage = lazy(() => import('../pages/provider-dashboard/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin-dashboard/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const ExplorePage = lazy(() => import('../pages/explore/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/explorar',
    element: <ExplorePage />
  },
  {
    path: '/iniciar-sesion',
    element: <LoginPage />
  },
  {
    path: '/registro-proveedor',
    element: <RegisterProviderPage />
  },
  {
    path: '/registro-usuario',
    element: <RegisterUserPage />
  },
  {
    path: '/categorias',
    element: <CategoriesPage />
  },
  {
    path: '/proveedor/:id',
    element: <ProviderProfilePage />
  },
  {
    path: '/solicitar-servicio/:id',
    element: <ServiceRequestPage />
  },
  {
    path: '/panel-proveedor',
    element: <ProviderDashboardPage />
  },
  {
    path: '/panel-admin',
    element: <AdminDashboardPage />
  },
  {
    path: '/sobre-task-zone',
    element: <AboutPage />
  },
  {
    path: '/terminos-y-condiciones',
    element: <TermsPage />
  },
  {
    path: '/politica-de-privacidad',
    element: <PrivacyPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;